// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-webform-submission{margin-bottom:2rem;font-size:.875rem}", "",{"version":3,"sources":["webpack://./src/Components/WebFormSubmission.scss"],"names":[],"mappings":"AAAA,0BACE,kBAAA,CACA,iBAAA","sourcesContent":[".order-webform-submission {\n  margin-bottom: 2rem;\n  font-size: 0.875rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
